import { getIframeObservable_DO_NOT_USE } from '@atlassian/embedded-confluence/getIframeObservable';

import { fg } from '@confluence/feature-gating';
/** Posts height and width to the window on resize */
export const subscribeToContentSize = () => window.addEventListener('load', resizeHandler);

export const resizeHandler = () => {
	const contentArea = document.getElementById('full-height-container');
	if (!contentArea) return;

	new ResizeObserver(postOnContentSizeChange).observe(contentArea);
};

export const postOnContentSizeChange = (entries: Array<ResizeObserverEntry>) => {
	const observableObject = getIframeObservable_DO_NOT_USE();
	const uniqueKey = observableObject?.object?.uniqueKey;

	entries.forEach(({ target: { scrollHeight, scrollWidth } }) => {
		window.parent?.postMessage(
			{
				type: 'contentSize',
				height: scrollHeight,
				width: scrollWidth,
				...(fg('platform_deprecate_lp_cc_embed') ? { uniqueKey } : {}),
			},
			'*',
		);
	});
};
